import React, { ReactNode } from 'react'

import Chip from 'components_new/atoms/Chip'

import NewSettingsItem from 'components_new/molecules/NewSettingsItem'

import {
  fieldRowId,
  FIELD_LABELS,
  MetricField
} from 'components_new/organisms/internal/MetricStudio/utils'

interface Props {
  actions?: ReactNode
  children?: ReactNode
  /** The field the row edits, for rows that are required. */
  field?: MetricField
  helperText?: ReactNode
  /** Marks the row as one of the fields that is still empty. */
  missing?: boolean
  /** Given for a row that edits something other than a required field. */
  title?: string
}

/**
 * One row of the form. A required row is labelled with a star and, while it is
 * empty, says so — eight fields on a long page are otherwise hard to find from
 * the count next to the save button.
 */
const FieldRow = (props: Props) => {
  const { actions, children, field, helperText, missing, title } = props

  return (
    <NewSettingsItem
      actions={actions}
      helperText={helperText}
      id={field ? fieldRowId(field) : undefined}
      title={field ? `${FIELD_LABELS[field]} *` : title ?? ''}
      titleAdornment={
        missing ? <Chip color="warning" label="Saknas" size="xsmall" /> : null
      }
    >
      {children}
    </NewSettingsItem>
  )
}

export default FieldRow
